export const SET = '/paymentGroups/set';
